@if (verifiedUser) {
  <section name="user info" class="user-info">
    <div class="user">{{userInfo.firstName}} {{userInfo.lastName}}, @if (currentOrg) {
      <span>{{(currentOrg.organizationName.length > 20)? (currentOrg.organizationName | slice:0:20)+'..':(currentOrg.organizationName)}}</span>
    }</div>
    @if (currentOrg) {
      <div class="title"><span>{{currentOrg.isOperator ? 'Operator' : currentOrg.isServiceComp ? 'Service Company' : currentOrg.isRegisteredAgent ? 'Registered Agent' : currentOrg.isGovAgency ? 'Gov. Agency' : ''}}</span> @if (currentOrg.operatorNumber) {
      <span>| Num: {{currentOrg.operatorNumber ? currentOrg.operatorNumber : ''}}</span>
    }</div>
  }
  <div class="account">
    <div class="tooltip-wrapper">
      <a href="/user/profile">User Account</a>
      <app-popper-tool-tip screenReaderText="Edit account profile">
      </app-popper-tool-tip>
    </div>
    <a class="tooltip-wrapper" #beforeNavMenu (click)="onLogoutClick()">Logout</a>
    @if (userOrgs && userOrgs.length>1) {
      <div class="tooltip-wrapper">
        <a routerLink="/switch-organization">Switch Organization</a>
        <app-popper-tool-tip screenReaderText="Switch between organizations">
        </app-popper-tool-tip>
      </div>
    }
  </div>
</section>
}
@if (!verifiedUser) {
  <section name="user info" class="user-info">
    <div class="account">
      <a #beforeNavMenu href="/authentication/login">Login</a> or
      <a href="/authentication/register">Register</a>
    </div>
  </section>
}
